// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"6":"a34d8276","857":"888640ae"}[chunkId] + ".css";
};